<div class="row col-12 col-sm-12 manage-user-container my-account-container">
  <div class="col-3 col-sm-3 my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyOrdersNavNode'"
      [childNavState]="'OrdersStatusNavNode'"></app-my-account-left-sidenav>
  </div>

  @if (canLoadPage) {
  <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <h1 class="manageUserTopHeader m-0">{{'common.text_account_orderHistory_orderStatus'|cxTranslate}}
    </h1>
    <div class="form-field-control edit-user-form-control my-section-box-inner">
      <div class="">
        <form [formGroup]="orderStatusForm" (click)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()">
          <ng-container>
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="container-cus-block">
                <div class="acc-sec-content">
                  <label class="control-label">{{'common.order_history_customer_ID'|cxTranslate}}</label>
                  <div class="select">
                    @if (orderStatusData?.b2bUnits?.length) {
                    <select name="customer" id="customerId" formControlName="customerId">
                      @for (opt of $any(orderStatusData)?.b2bUnits; track opt) {
                      <option [disabled]="opt?.orderBlocked" [ngValue]="opt.uid"
                        [ngClass]="opt?.orderBlocked ? 'bgGrey' : ''">
                        @if (opt?.addresses && opt?.addresses[0]?.sapCustomerID) {
                        <span> {{
                          opt?.addresses[0]?.sapCustomerID }}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.addresses && opt?.addresses[0]?.companyName) {
                        <span> {{
                          opt?.addresses[0]?.companyName }}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.addresses && opt?.addresses[0]?.formattedAddress) {
                        <span> {{
                          opt?.addresses[0]?.formattedAddress }}</span>
                        }
                      </option>
                      }
                    </select>
                    }
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- email address -->
          <div class="order-status-wrapper">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="email" class="control-label">{{'common.text_account_customerPONumber'|cxTranslate}}</label>
              <input type="text" class="form-control outline email-readonly" formControlName="poNumber" />
            </div>
            <!--Title-->
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="confirmPassword"
                class="control-label">{{'common.text_account_orderHistory_orderStatus'|cxTranslate}}</label>
              <div class="select-box">
                <select name="industry" class="form-control outline" formControlName="orderStatus">
                  @for (item of $any(orderStatusData).orderStatuses; track item) {
                  <option [value]="item.code">{{item.name}}
                  </option>
                  }
                </select>
              </div>
            </div>
          </div>
          <!--First Name-->
          <div class="order-status-wrapper">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="firstName" class="control-label">{{'common.text_account_kbOrderNumber'|cxTranslate}}</label>
              <input type="text" formControlName="orderNumber" class="form-control outline">
            </div>
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 order-status-datePicker">
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <label for="lastName" class="control-label">{{'common.text_account_OrderDate'|cxTranslate}}</label>
                <div
                  class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12 p-0 form-group mb-3 align-self-end date-from">
                  <input class="form-control outline bsdpicker kb-datePickerIcon" #dp="bsDatepicker"
                    (click)="openDatepicker(dp)" bsDatepicker formControlName="orderDateFrom" [maxDate]="today"
                    [ngClass]="{ 'is-valid': (orderStatusForm.controls['orderDateFrom'].dirty || submitted) && !orderStatusForm.controls['orderDateFrom'].errors, 'is-invalid': (orderStatusForm.controls['orderDateFrom'].dirty || submitted) && orderStatusForm.controls['orderDateFrom'].errors }"
                    [bsConfig]="{ dateInputFormat: bsConfigFormat, showWeekNumbers:false, displayOneMonthRange: true }">
                  <div class="invalid-feedback">
                    @if ( orderStatusForm.controls['orderDateFrom']?.errors &&
                    orderStatusForm.controls['orderDateFrom']?.errors['required']) {
                    <span
                      class="text-danger-show">{{'common.NotBlank_orderHistoryForm_startDate'|cxTranslate}}<br>{{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <label for="lastName" class="control-label">{{'common.text_account_OrderDateTo'|cxTranslate}}</label>
                <div class="col-xs-12 col-12 col-sm-12 col-md-12 col-lg-12 p-0 form-group mb-3 align-self-end date-to">
                  <input class="form-control outline bsdpicker1 kb-datePickerIcon" bsDatepicker #dp2="bsDatepicker"
                    (click)="openDatepicker(dp2)"
                    [ngClass]="{ 'is-valid': (orderStatusForm.controls['orderDateTo'].dirty || submitted) && !orderStatusForm.controls['orderDateTo'].errors, 'is-invalid': (orderStatusForm.controls['orderDateTo'].dirty || submitted) && orderStatusForm.controls['orderDateTo'].errors }"
                    formControlName="orderDateTo" [maxDate]="today"
                    [bsConfig]="{ dateInputFormat: bsConfigFormat,showWeekNumbers:false, displayOneMonthRange: true }">
                  <div class="invalid-feedback">
                    @if ( orderStatusForm.controls['orderDateTo']?.errors &&
                    orderStatusForm.controls['orderDateTo']?.errors['required']) {
                    <span class="text-danger-show">{{'common.NotBlank_orderHistoryForm_endDate'|cxTranslate}}
                      <br>{{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Company Name-->
          <div class="order-status-wrapper">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <label for="companyName" class="control-label">{{'common.text_account_kbpartNumber'|cxTranslate}}</label>
              <input type="text" formControlName="cpn" class="form-control outline" name="cpn">
            </div>
            <!--Sold To-->
            @if ($any(orderStatusData)?.showCoworkersOrder) {
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6 requestAccess d-flex">
              <div class="form-check d-flex align-items-end order-status-checkbox">
                <input class="form-check-input" formControlName="showCoworkersOrder" [value]="coWorker" type="checkbox">
                <label class="form-check-label checkbox-label co-worker" for="distributor">
                  {{'common.text_Show_orders_of_coworkers'|cxTranslate}}
                </label>
              </div>
            </div>
            }
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 btn-group d-flex justify-content-end order-status-buttonBlock">
            <button (click)="reset()" class="lock-btn primary-btn">{{'common.text_account_reset'|cxTranslate}}</button>
            <button (click)="search()" class="save-btn">{{'common.search_advanced_search'|cxTranslate}}
              <img class="arrow-img" src="/icons/link-grey.svg">
            </button>
          </div>
          @if (searchDataList?.kbStatusMessageWSDTO?.status==='noresults') {
          <div class="sort-section d-flex justify-content-center">
            <div class="row">
              <div class="account-section-content content-empty">
                {{'common.text_account_orderHistory_emptyOrderHistory'|cxTranslate}}</div>
            </div>
          </div>
          }
        </form>
      </div>
    </div>
    @if (searchDataList && searchDataList.results?.length>0) {
    <div class="sort-section my-section-box">
      <div class="gray-search-result-box">
        {{totalResults}}<div class="d-md-none d-lg-none">
          <div class="mobile-select">
            <span class="mobile-select-label">Sort by:</span>
            <div class="select-box w-100">
              <select class="mobile-sorting-dropdown form-control" name="sort">
                <option selected="selected">
                  Date-Desc</option>
                <option>
                  Date-Asc</option>
                <option>
                  Name-Asc</option>
                <option>
                  Name-Desc</option>
                <option>
                  Email-Asc</option>
                <option>
                  Email-Desc</option>
                <option>
                  Active-Asc</option>
                <option>
                  Active-Desc</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="order-status-table mycompany-manageUser">
        <table class="responsive-table table table-bordered table-blue order-status-table">
          <thead>
            <tr class="responsive-table-head hidden-xs hidden-sm">
              <th scope="col">
                <a class="a-underline f-s"
                  (click)="sort('byCategory')"><span>{{'common.text_account_table_header_category'|cxTranslate}}</span></a>
              </th>
              <th scope="col">
                <a class="a-underline f-s"
                  (click)="sort('byDate')"><span>{{'common.text_account_table_header_date'|cxTranslate}}</span></a>
              </th>
              <th scope="col" class="f-s">
                <a class="a-underline f-s"
                  (click)="sort('byCode')"><span>{{'common.text_account_table_header_naNumber'|cxTranslate}}</span></a>
              </th>
              <th scope="col" class="f-s">
                <a class="a-underline f-s"
                  (click)="sort('byPO')"><span>{{'common.text_account_customerPONumber'|cxTranslate}}</span></a>
              </th>
              <th scope="col" class="f-s">
                <a class="a-underline f-s"
                  (click)="sort('byOrderType')"><span>{{'common.quick_order_page_ordertype'|cxTranslate}}</span></a>
              </th>
              <th scope="col">
                <a class="a-underline f-s"
                  (click)="sort('byStatus')"><span>{{'common.text_account_table_header_status'|cxTranslate}}</span></a>
              </th>
            </tr>
          </thead>
          @if (searchDataList) {
          <tbody>
            @for (item of searchDataList?.results; track item) {
            <tr class="responsive-table-item">
              <td class="responsive-table-cell name">
                <span
                  class="mycompany-registration-lable d-md-block d-lg-none">{{'common.text_account_table_header_category'|cxTranslate}}</span>
                <span class="mycompnay-registration-value">{{item?.orderCategory?.name}}</span>
              </td>
              <td class="responsive-table-cell email">
                <span
                  class="mycompany-registration-lable d-md-block d-lg-none">{{'common.text_account_table_header_date'|cxTranslate}}</span>
                <span class="mycompnay-registration-value">{{item?.placedBaserStoreFormat}}</span>
              </td>
              <td class="responsive-table-cell email">
                <span
                  class="mycompany-registration-lable d-md-block d-lg-none">{{'common.text_account_table_header_naNumber'|cxTranslate}}</span>
                <a [routerLink]="['/order']" [queryParams]="{orderId:openNewTab(item)}"
                  (click)="redirectOrder(item)"><span
                    class="mycompnay-registration-value pointer">{{item?.code}}</span></a>
              </td>
              <td class="responsive-table-cell email">
                <span
                  class="mycompany-registration-lable d-md-block d-lg-none">{{'common.text_account_customerPONumber'|cxTranslate}}</span>
                <a [routerLink]="['/order']" [queryParams]="{orderId:openNewTab(item)}"
                  (click)="redirectOrder(item)"><span
                    class="mycompnay-registration-value pointer">{{item?.purchaseOrderNumber}}</span></a>
              </td>
              <td class="responsive-table-cell email">
                <span
                  class="mycompany-registration-lable d-md-block d-lg-none">{{'common.quick_order_page_ordertype'|cxTranslate}}</span>
                @if (item?.orderType) {
                <span class="mycompnay-registration-value">{{item?.orderType?.name}}</span>
                }
                @if (!item?.orderType && item?.docType) {
                <span class="mycompnay-registration-value">{{item?.docType}}</span>
                }
              </td>
              <td class="responsive-table-cell email">
                <span
                  class="mycompany-registration-lable d-md-block d-lg-none">{{'common.text_account_table_header_status'|cxTranslate}}</span>
                @if (item?.orderStatus?.code !== 'C') {
                <span class="mycompnay-registration-value">
                  {{ item?.orderStatus?.name }}
                </span>
                } @else {
                <span class="mycompnay-registration-value"></span>
                }
              </td>
            </tr>
            }
          </tbody>
          }
        </table>
      </div>
      <div class="account-orderhistory-pagination company-users-pagination">
        <div class="product__list--wrapper">
          <div class="pagination-bar">
            <div class="pagination-toolbar">
              <div class="row sort-refine-bar">
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-6 bottom-result">
                  <div class="pagination-result">
                    {{pageItems}} </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-8 col-lg-6 kb-pagination-right kb-pagination">
                  <kb-pagination [pagination]="searchDataList?.pagination" [defaultPage]="0"
                    (viewPageEvent)="changePageCustom($event, searchDataList)"></kb-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>